import { bindActionCreators } from "redux";
import { store } from "../store";
import { Auth } from "./authActions";
import { dashboardActions } from "./dashboardActions";
import {AutoProvisioning} from "./autoprovisioningAction"
export const actions = {
  ...Auth,
  ...dashboardActions,
  ...AutoProvisioning
};

export default bindActionCreators(actions, store.dispatch);
